import { render, staticRenderFns } from "./TeacherTrainStudentDetial.vue?vue&type=template&id=25362126&scoped=true"
import script from "./TeacherTrainStudentDetial.vue?vue&type=script&lang=js"
export * from "./TeacherTrainStudentDetial.vue?vue&type=script&lang=js"
import style0 from "./TeacherTrainStudentDetial.vue?vue&type=style&index=0&id=25362126&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25362126",
  null
  
)

export default component.exports